module.exports = __webpack_public_path__ + "long-jumps.08ebd78f7be96fc4763cd323ca93f1e6.svg";